import React, { useEffect } from 'react';

import { Layout } from 'layouts';
import { HugggListContainer } from 'components';
import { PageTitle } from 'components/misc';

import dictionary from 'config/dictionary';
import { useAnalytics } from 'hooks';

const MyHugggs = () => {
  const analytics = useAnalytics();

  useEffect(() => {
    analytics.screenViewedMyHugggs();
  }, [analytics]);

  return (
    <Layout showBackButton={false} title={dictionary.myHugggs.title}>
      <PageTitle title={dictionary.myHugggs.title} />

      <HugggListContainer />
    </Layout>
  );
};

export default MyHugggs;
